<div class="loader" *ngIf="exibirLoader">
    <app-loader></app-loader>
 </div>
  
<div class="conteudo">
    <div class="apenas--mobile">
        <div class="container-principal__header">
            <dynamic-form [fields]="regLabelMenuCacauLover"></dynamic-form>
        </div>
    </div>
    <div class="apenas--desktop">
        <div class="container-principal__header header--desktop">
            <span class="fa fa-envelope header__icone"></span>
            <label class="cs_label header__titulo">Atendimento SAC</label>
        </div>
    </div>
</div>

<div class="atendimento">
    <dynamic-form [fields]="regConfigCadastroCacauLover" (submit)="submit($event)"></dynamic-form>
</div>